let map, currentMarker;
let markers = [];
let user_markers = [];
function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 43.3877524, lng: 10.7533154 },
    zoom: 5.55,
    mapId: '32de31b570ea807b',
    mapTypeControl: false
  });
  
  let search = new google.maps.places.Autocomplete(
    (document.getElementById('search')), {
      types: ['geocode']
    });

  search.bindTo("bounds", map);

  search.addListener("place_changed", () => {

    const place = search.getPlace();
    let closest_marker = find_closest_marker(place.geometry.location);

    if (!place.geometry || !place.geometry.location) {
      window.alert("No details available for input: '" + place.name + "'");
      return;
    }
    else{
      
      if(currentMarker != null){
        currentMarker.setMap(null);
      }
      for(i = 0; i < user_markers.length; i++){
        user_markers[i].setMap(null);
      }

      let search_marker = new google.maps.Marker({
        position: {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()},
        map: map,
        title: place.name,
      });

      user_markers.push(search_marker);
  
      var bound = new google.maps.LatLngBounds();
      let locations = [search_marker.getPosition(), closest_marker.getPosition()];
      
      for (i = 0; i < locations.length; i++) {
        bound.extend(locations[i]);
      }

      map.fitBounds(bound);
      
      if(window.innerWidth < 767){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#map").offset().top - document.getElementById('header').offsetHeight
      }, 600);
      }
    }

  });
  
  const locationButton = document.createElement("button");

  locationButton.textContent = currentLabel;
  locationButton.classList.add("custom-map-control-button");
  map.controls[google.maps.ControlPosition.TOP_LEFT].push(locationButton);
  locationButton.addEventListener("click", () => {
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          for(i = 0; i < user_markers.length; i++){
            user_markers[i].setMap(null);
          }
          if(currentMarker != null){
            currentMarker.setMap(null);
          }
          currentMarker = new google.maps.Marker({
            position: {lat: pos.lat, lng: pos.lng},
            map: map,
          });
          map.setCenter(pos);
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter());
        }
      );
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter());
    }
  });
}

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
  infoWindow.setPosition(pos);
  infoWindow.setContent(
    browserHasGeolocation
      ? "Error: The Geolocation service failed."
      : "Error: Your browser doesn't support geolocation."
  );
  infoWindow.open(map);
}

window.initMap = initMap;

document.addEventListener("DOMContentLoaded", function(event) {
  retrievePoints();
  
  let listPositions = document.querySelector(".listPositions");
  let buttonUp = document.getElementById("buttonUp");
  buttonUp.addEventListener("click", e=>{
    if(listPositions.classList.contains("up")){
       listPositions.classList.remove("up");
       buttonUp.classList.remove("rotate");
       document.body.classList.remove("overflow-y");
    }
    else{
       listPositions.classList.add("up");
       buttonUp.classList.add("rotate");
       document.body.classList.add("overflow-y");
    }
  });
  
});
var POINT_DATA;
var MAP;

async function retrievePoints(){
  var data = new FormData();
  data.append( "request", "request" );
  //fetch('https://contacts.moma.it/store-request-edited.php', {
  fetch('https://scdn.moma.it/storelocator/locations.php', {
    method: 'POST', // or 'PUT'
    body: data,
  })
  .then(response => response.json())
  .then(data => {
    POINT_DATA = data;

    print_first_slide();
    initSlider();
    initMap();
    console.log(data);
    for (const [key, stati] of Object.entries(data)) {
    	for (const [key, stores] of Object.entries(stati)) {
        stores.forEach(store => {
          let contentString = 
              '<div class="popup-content" style="width: 301px;">' +
              '<div class="infowindow-text text-small">' +
              '<h4 class="infowindow-title text-bold">'+store.titolo+'</h4>' +
              store.text +
              '</p>' +
              '</div>' +
              '</div>';

          let infowindow = new google.maps.InfoWindow({
            content: contentString,
          });
          let icon = {
            // url: 'https://contacts.moma.it/images/pin-moma.svg', // url
            url: 'https://cdn.shopify.com/s/files/1/0628/3293/5154/files/pin-moma.svg?v=1673355860', // url
            scaledSize: new google.maps.Size(40, 40), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(0, 0) // anchor
          };
          let marker = new google.maps.Marker({
            position: {lat: parseFloat(store.lat), lng: parseFloat(store.lng)},
            title: store.title,
            map: map,
            icon: icon,
          });

          marker.addListener("click", () => {
            marker.setAnimation(google.maps.Animation.BOUNCE);

            infowindow.open({
              anchor: marker,
              shouldFocus: false,
            });
            infowindow.addListener('closeclick', () => {
              marker.setAnimation(null);
            })
          });
          markers.push(marker);
        })
      }
    }

    var styles = [
      {
        width: 50,
        height: 50,
        className: "custom-cluster-marker",
      },
      {
        width: 60,
        height: 60,
        className: "custom-cluster-marker-medium",
      },
      {
        width: 90,
        height: 90,
        className: "custom-cluster-marker-big",
      },
    ];

    var markerCluster = new MarkerClusterer(map, markers,{
        styles: styles,
        clusterClass: "custom-cluster-marker",
        anchor: [90,90], 
      }
    );
    return data;
  })
  .catch((error) => {
    console.log('Error:', error);
  });
}

function initSlider(){
  $("#slider").slick({
    dots: false,
    swipe: false,
    arrows: false,
    slidesToShow: 1,
    adaptiveHeight: true
  });
}

function print_first_slide(){
  document.getElementById("state").innerHTML = '';
  Object.keys(POINT_DATA).forEach(function(state){
    document.getElementById("state").innerHTML += '<div class="provinciaSingola" onClick="print_second_slide(\''+state+'\')">' +
      '<span class="text-uppercase">'+state+'</span>'
    '</div>';
  });
}
function print_second_slide(state){
  let arrowRight = '<svg id="arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 84" style="enable-background:new 0 0 100 84;" xml:space="preserve">' +
    '<style type="text/css">' +
        '#arrow .st0{fill:#000;}' +
    '</style>' +
    '<g id="Componente_4_2" transform="translate(103.464 86.312) rotate(180)">' +
      '<g id="Raggruppa_2118" transform="translate(599.422 2176.733) rotate(180)">' +
        '<g id="Raggruppa_2079" transform="translate(497 2095.494)">' +
        '<rect x="0.3" y="36" class="st0" width="98.3" height="3"></rect>' +
            '</g>' +
            '<g id="Raggruppa_2115" transform="translate(497 2087.494)">' +
                '<rect x="-6.5" y="19.4" transform="matrix(0.7194 -0.6946 0.6946 0.7194 -9.53 18.2742)" class="st0" width="48.7" height="3"></rect>' +
            '</g>' +
            '<g id="Raggruppa_2116" transform="translate(497 2141.5)">' +
                '<rect x="16.3" y="-9.4" transform="matrix(0.6945 -0.7195 0.7195 0.6945 -5.2785 17.4004)" class="st0" width="3" height="48.7"></rect>' +
            '</g>' +
        '</g>' +
    '</g>' +
  '</svg>';
  document.getElementById("province").innerHTML = '<div class="secondSlideHeader colorBlack" onClick="goto_first_slide()"><h3 class="m-0 acuminProWide text-center font-weight-bold text-uppercase">'+state+'</h3><span class="arrow">'+arrowRight+'</span></div>';
  Object.keys(POINT_DATA[state]).forEach(function(province){
    document.getElementById("province").innerHTML += '<div class="provinciaSingola" onClick="print_last_slide(\''+state+'\', \''+province+'\')">' +
      '<span class="text-uppercase">'+province+'</span>'
    '</div>';
  });
  $("#slider").slick("slickGoTo", 1);
}

function print_last_slide(state, provincia){
  let arrowRight = '<svg id="arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 84" style="enable-background:new 0 0 100 84;" xml:space="preserve">' +
    '<style type="text/css">' +
        '#arrow .st0{fill:#000;}' +
    '</style>' +
    '<g id="Componente_4_2" transform="translate(103.464 86.312) rotate(180)">' +
      '<g id="Raggruppa_2118" transform="translate(599.422 2176.733) rotate(180)">' +
        '<g id="Raggruppa_2079" transform="translate(497 2095.494)">' +
        '<rect x="0.3" y="36" class="st0" width="98.3" height="3"></rect>' +
            '</g>' +
            '<g id="Raggruppa_2115" transform="translate(497 2087.494)">' +
                '<rect x="-6.5" y="19.4" transform="matrix(0.7194 -0.6946 0.6946 0.7194 -9.53 18.2742)" class="st0" width="48.7" height="3"></rect>' +
            '</g>' +
            '<g id="Raggruppa_2116" transform="translate(497 2141.5)">' +
                '<rect x="16.3" y="-9.4" transform="matrix(0.6945 -0.7195 0.7195 0.6945 -5.2785 17.4004)" class="st0" width="3" height="48.7"></rect>' +
            '</g>' +
        '</g>' +
    '</g>' +
  '</svg>';
  
  document.getElementById("stores").innerHTML = '<div class="secondSlideHeader colorBlack" onClick="goto_first_slide()"><h3 class="m-0 acuminProWide text-center font-weight-bold text-uppercase">'+provincia+'</h3><span class="arrow">'+arrowRight+'</span></div>';
  arrayOfLatLngs = new Array();
  Object.keys(POINT_DATA[state][provincia]).forEach(function(punti){
    var elem = POINT_DATA[state][provincia][punti];
    var titolo = elem.titolo;
    var indirizzo = elem.indirizzo;
    var cap = elem.cap;
    var localita = elem.comune;

    document.getElementById("stores").innerHTML += '<div class="negozioSingolo"><div class="inner d-flex flex-wrap colorBlue">' +
      '<div class="col-12 p-0">' +
      	'<span class="font-weight-bold mb-3 d-inline-block text-uppercase">'+titolo+'</span>' +
      '</div>' +
      '<div class="col-12 col-md-6 p-0">' +
        '<p class="small mb-0 pallino">'+indirizzo+'</p>' +
        '<p class="small mb-0 pallino">'+cap+' '+localita+'</p>' +
      '</div>' +
      '<div class="col-12 col-md-4 offset-2 p-0">' +
      '<span class="takeMeHere d-inline-block" onClick="goto_store(\''+state+'\', \''+provincia+'\', \''+punti+'\')"><img src="https://cdn.shopify.com/s/files/1/0628/3293/5154/files/pin-moma.svg?v=1673355860" style="height: 1.5em; vertical-align: middle;" class="d-inline-block mr-2" />Portami qui</span>'+
    '</div></div></div>';
    arrayOfLatLngs.push([elem.lat, elem.lng]);
  });
  $("#slider").slick("slickGoTo", 2);
  document.querySelector('#sliderContainer').scrollTop = 0;
}

function goto_store(state, provincia, punto){
  var elem = POINT_DATA[state][provincia][punto];
  map.panTo(new google.maps.LatLng(elem.lat, elem.lng));
  map.setZoom(15);
  let listPositions = document.querySelector(".listPositions");
  let buttonUp = document.getElementById("buttonUp");
  listPositions.classList.remove("up");
  buttonUp.classList.remove("rotate");
  document.body.classList.remove("overflow-y");
  if(window.innerWidth < 992){
    goto_first_slide(992);
  }
}

function goto_first_slide(width){
  if(width != 992){
    map.panTo(new google.maps.LatLng(41.8651251, 10.7790812));
    map.setZoom(5);
    $("#slider").slick("prev");
  }
  else{
    $("#slider").slick("slickGoTo", 0);
  }
}

function find_closest_marker(event) {
  var distances = [];
  var closest = -1;
  for (i = 0; i < markers.length; i++) {
    var d = google.maps.geometry.spherical.computeDistanceBetween(markers[i].position, event);
    distances[i] = d;
    if (closest == -1 || d < distances[closest]) {
      closest = i;
    }
  }

  return markers[closest];
}